export var OwnerRole;
(function (OwnerRole) {
    OwnerRole[OwnerRole["Director"] = 0] = "Director";
    OwnerRole[OwnerRole["DirectorAndOwner"] = 1] = "DirectorAndOwner";
    OwnerRole[OwnerRole["UBO"] = 2] = "UBO";
    OwnerRole[OwnerRole["Shareholder"] = 3] = "Shareholder";
    OwnerRole[OwnerRole["Regular"] = 4] = "Regular";
})(OwnerRole || (OwnerRole = {}));
